import React, { Component } from 'react'
import { Body } from '../Shell/Shell'
import * as api from '../../requests'
import { CreateInstancesFromJson } from '../Wizard2/WizardClasses'
import x2js from 'x2js'
import { DumbField } from 'components/Wizard2/Field'
import { Select } from 'components/Wizard2/fieldComponents/Form'
import { populateDesigner } from 'components/Designer2/DesignerActions'
import store from '../../store'
import './Migrate.scss'

const convert = new x2js()

export default class Migrate extends Component {
  constructor() {
    super()
    this.state = {
      wizards: null,
      currentWizard: '',
      finished: false,
      categoryId: '',
      categoryAdded: false,
    }
  }
  startMigration = async () => {
    await new Promise((resolve) => {
      api.GET_ALL_WIZARDS(null, (response) => {
        // console.log(response)
        let wizards = {}
        response.forEach((wizard) => {
          wizards[wizard.FORM_DEFINITION_ID] = wizard
        })
        this.setState({ wizards: wizards }, () => {
          resolve()
        })
      })
    })
    await this.replaceDefinitionJson()
    await this.saveNewDefinitions()
  }
  replaceDefinitionJson = () => {
    return new Promise((resolve) => {
      console.log('Started replacing json')
      let wizards = { ...this.state.wizards }
      // console.log(this.state.wizards)
      Object.keys(this.state.wizards).forEach((formDefinitionId) => {
        let wizard = { ...this.state.wizards[formDefinitionId] }
        // this.setState({ currentWizard: wizard.TITLE });
        console.log(wizard.TITLE)
        let parsed = CreateInstancesFromJson(JSON.parse(wizard.STEPS_JSON))
        const metadata = this.resolveMetadataStructure(wizard.METADATA)
        wizard.METADATA = convert.js2xml(metadata)
        wizard.STEPS_JSON = JSON.stringify(parsed)
        wizards[formDefinitionId] = wizard
      })
      this.setState(
        (state) => ({
          wizards,
        }),
        () => {
          resolve()
        }
      )
    })
  }
  resolveMetadataStructure = (METADATA) => {
    if (METADATA) {
      const metadata = convert.xml2js(METADATA)
      return this.recursivelyRemoveMetadataTags(metadata)
    } else {
      return ''
    }
  }
  recursivelyRemoveMetadataTags = (metadata) => {
    if (metadata.METADATA !== undefined) {
      return this.recursivelyRemoveMetadataTags(metadata.METADATA)
    } else {
      return metadata
    }
  }
  saveNewDefinitions = () => {
    let promises = Object.keys(this.state.wizards).map(
      (formDefinitionId) =>
        new Promise((resolve) => {
          api.SAVE_WIZARD(this.state.wizards[formDefinitionId], (id) => {
            this.setState({ currentWizard: this.state.wizards[formDefinitionId].TITLE })
            resolve(id)
          })
        })
    )
    Promise.all(promises).then(() => {
      this.setState({
        finished: true,
      })
    })
  }
  setCategoryId = (e) => {
    this.setState({
      categoryId: e.target.value,
      categoryAdded: false,
    })
  }
  addFormCategory = () => {
    api.GET_APP_SETTING_BY_NAME('FORM_MANAGER_STRUCTURE', (setting) => {
      const structure = JSON.parse(setting.VALUE)
      // console.log(structure);
      const newStructure = {
        ...structure,
        categories: {
          ...structure.categories,
          [this.state.categoryId]: {},
        },
        categoriesOrder: {
          ...structure.categoriesOrder,
          [this.state.categoryId]: [],
        },
      }
      // console.log(newStructure);
      api.UPDATE_APP_SETTING_BY_ID(
        setting.APP_SETTING_ID,
        {
          NAME: 'FORM_MANAGER_STRUCTURE',
          VALUE: JSON.stringify(newStructure),
          CATEGORY: 'ADMIN',
          DESCR: '',
        },
        (data) => {
          this.setState({
            categoryAdded: true,
          })
        }
      )
    })
  }
  render() {
    return (
      <Body className="wizard migration-page">
        <div style={rowStyle} className="section">
          <h3 style={labelStyle}>Download and self-clean all wizards</h3>
          <button className="btn btn-primary btn-raised" onClick={this.startMigration}>
            Start Migration
          </button>
          {this.state.finished ? (
            <p style={{ color: 'rgb(41, 187, 11)', fontStyle: 'italic' }}>Finished</p>
          ) : (
            <p>{`Currently Migrating: ${this.state.currentWizard}`}</p>
          )}
        </div>
        <hr />
        <StepTemplateSection />
      </Body>
    )
  }
}

const rowStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '10px 0px',
}

const labelStyle = { fontWeight: 800, fontSize: 18 }

const StepTemplateSection = () => {
  const [wizards, setWizards] = React.useState({})
  const [selectedWizard, setSelectedWizard] = React.useState('')
  const [selectedStep, setSelectedStep] = React.useState('')
  const [migrationStarted, setMigrationStarted] = React.useState(null)
  const [migrationSucceeded, setMigrationSucceeded] = React.useState(null)
  const [selectedWizards, setSelectedWizards] = React.useState({})

  React.useEffect(() => {
    api.GET_ALL_WIZARDS(
      null,
      (response) => {
        // console.log(response)
        const wizards = response.reduce((wizards, wizard) => {
          wizards[wizard.FORM_DEFINITION_ID] = {
            ...wizard,
            STEPS_JSON: JSON.parse(wizard.STEPS_JSON),
          }
          return wizards
        }, {})
        setWizards(wizards)
      },
      (err) => {
        console.error(err)
      }
    )
  }, [])

  const hasLoaded = Object.keys(wizards).length

  const wizardOptions = React.useMemo(
    () =>
      Object.values(wizards)
        .filter((opt) => {
          const wizard = opt.STEPS_JSON
          return Object.values(wizard.steps).some((step) => !!step.templateId)
        })
        .map((wizard) => ({
          value: wizard.FORM_DEFINITION_ID,
          label: wizard.TITLE,
        })),
    [wizards]
  )

  const stepOptions = React.useMemo(
    () =>
      selectedWizard
        ? Object.values(wizards[selectedWizard].STEPS_JSON.steps)
            .filter((step) => step.templateId)
            .map((step) => ({
              value: step.stepId,
              label: `${step.templateId} | ${step.title}`,
            }))
        : [],
    [selectedWizard, wizards]
  )

  const wizardsToMigrate = React.useMemo(() => {
    if (!selectedWizard || !selectedStep) {
      return []
    }
    const templateId = wizards[selectedWizard].STEPS_JSON.steps[selectedStep].templateId
    return Object.values(wizards)
      .filter((wizard) => wizard.FORM_DEFINITION_ID.toString() !== selectedWizard)
      .filter((wizard) =>
        Object.values(wizard.STEPS_JSON.steps).some((step) => step.templateId === templateId)
      )
  }, [wizards, selectedWizard, selectedStep])

  const selectAllWizards = (wizards) => {
    setSelectedWizards(
      wizards.reduce((obj, wizard) => {
        obj[wizard.FORM_DEFINITION_ID] = true
        return obj
      }, {})
    )
  }

  const deselectAllWizards = () => {
    setSelectedWizards({})
  }

  React.useEffect(() => {
    selectAllWizards(wizardsToMigrate)
  }, [wizardsToMigrate])

  const startMigration = () => {
    setMigrationStarted(true)
    const donorWizard = CreateInstancesFromJson(wizards[selectedWizard].STEPS_JSON)
    const templateId = donorWizard.steps[selectedStep].templateId
    store.dispatch(populateDesigner(wizards[selectedWizard], donorWizard))
    store.dispatch({
      type: 'COPY_STEP_CONTENTS',
      stepId: selectedStep,
      preserveFieldIds: true,
    })
    const promises = wizardsToMigrate
      .filter((wizard) => selectedWizards[wizard.FORM_DEFINITION_ID])
      .map((wizard) => {
        const parsedWizard = CreateInstancesFromJson(wizard.STEPS_JSON)
        store.dispatch(populateDesigner(wizard, parsedWizard))
        const targetStepId = Object.values(parsedWizard.steps).find(
          (step) => step.templateId === templateId
        ).stepId
        store.dispatch({
          type: 'PASTE_STEP_CONTENTS',
          stepId: targetStepId,
        })
        const extractedWizard = store.getState().designer.wizard
        const migratedWizard = {
          ...wizard,
          STEPS_JSON: JSON.stringify({
            stepOrder: extractedWizard.stepOrder,
            steps: extractedWizard.steps,
            sections: extractedWizard.sections,
            fields: extractedWizard.fields,
          }),
        }
        return new Promise((resolve, reject) => {
          api.SAVE_WIZARD(migratedWizard, resolve, reject)
        })
      })
    Promise.all(promises).then(() => {
      setMigrationSucceeded(true)
    })
  }

  return (
    <div
      className="section"
      style={{ ...rowStyle, opacity: hasLoaded ? 1 : 0.2, pointerEvents: hasLoaded ? '' : 'none' }}
    >
      {!hasLoaded ? <span>Loading...</span> : null}
      <h3 style={labelStyle}>Update all wizard step templates</h3>
      <p className="description">
        Use this tool to migrate a chosen template step for all wizards. Select a wizard to copy
        from, and a template step, and this tool will find all wizards with the same template id and
        replace their contents with the contents of the selected step. Please do not use this tool
        unless you understand exactly what it will do.
      </p>
      <p className="description">
        Here are some general guidlines for using this tool successfully:
      </p>
      <ul>
        <li>Backup the form defintions before starting the migration as a precaution.</li>
        <li>
          Step template IDs may only be used <strong>ONCE</strong> per wizard.
        </li>
        <li>
          Ensure that the logic and conditions of fields in the step you will be copying from, are
          all self-contained. Meaning, they do not reference any fields outside of the step they are
          in. Non-self-contained logic will still be copied, but will need to be manually updated
          with references to the external fields.
        </li>
        <li>
          This migration occurs in your browser. <strong>Do not</strong> close your browser window
          until the migration is completed.
        </li>
        <li>
          Avoid overusing this tool for bulk copy/paste actions. Used correctly this tool can speed
          up migrating wizard steps significantly, but there's a high surface-area for potential
          bugs and errors. While the tool is not known to be unstable, it is advised to only use it
          when it will save significant amounts of time.
        </li>
        <li>
          Note that this migration will add a new entry in the version history for each affected
          wizard.
        </li>
        <li>May God have mercy on your soul.</li>
      </ul>
      <DumbField label="Pick a wizard from which to copy">
        <Select
          options={[{ value: '', label: '[Pick a Wizard]' }, ...wizardOptions]}
          value={selectedWizard}
          onChange={(value) => {
            setSelectedWizard(value)
            setSelectedStep('')
            setSelectedWizards({})
          }}
        />
      </DumbField>
      <DumbField label="Pick a template step from which to copy">
        <Select
          options={[{ value: '', label: '[Pick a Template Step]' }, ...stepOptions]}
          value={selectedStep}
          onChange={(value) => setSelectedStep(value)}
          disabled={!selectedWizard}
        />
      </DumbField>
      {selectedWizard && selectedStep ? (
        <React.Fragment>
          <h4>Select which wizards will be affected by this migration:</h4>
          <div className="flex-row">
            <button
              onClick={() => selectAllWizards(wizardsToMigrate)}
              className="btn btn-primary btn-raised"
              style={{ marginRight: 10 }}
            >
              Select All
            </button>
            <button onClick={deselectAllWizards} className="btn btn-primary btn-raised">
              Select None
            </button>
          </div>
          <ul>
            {wizardsToMigrate.map((wiz, i) => (
              <li key={i}>
                <input
                  type="checkbox"
                  style={{ verticalAlign: 'text-top', display: 'inline-block', marginRight: 10 }}
                  value={!!selectedWizards[wiz.FORM_DEFINITION_ID]}
                  checked={!!selectedWizards[wiz.FORM_DEFINITION_ID]}
                  onChange={(e) => {
                    const selected = e.target.checked
                    setSelectedWizards((s) => ({
                      ...s,
                      [wiz.FORM_DEFINITION_ID]: selected,
                    }))
                  }}
                />
                {wiz.FORM_DEFINITION_ID} - {wiz.TITLE}
              </li>
            ))}
          </ul>
        </React.Fragment>
      ) : null}
      {selectedWizard && selectedStep ? (
        <p className="danger-text">
          Warning: This action is <u>permanent</u> and potentially destructive. It is highly advised
          that you <u>backup all form definitions</u> before starting this migration. While the
          migration is running <u>do not close your browser window</u>.
        </p>
      ) : null}
      <button
        className="btn btn-danger btn-raised"
        disabled={!selectedWizard || !selectedStep}
        onClick={startMigration}
      >
        Start Migration
      </button>
      {migrationStarted && migrationSucceeded ? <p>Migration completed successfully</p> : null}
      {migrationStarted && migrationSucceeded === null ? (
        <p>
          Migration running, <strong>do not close this browser window</strong>
        </p>
      ) : null}
    </div>
  )
}
